import { render, staticRenderFns } from "./OrganizeInvite.vue?vue&type=template&id=56605f02&scoped=true&"
import script from "./OrganizeInvite.vue?vue&type=script&lang=js&"
export * from "./OrganizeInvite.vue?vue&type=script&lang=js&"
import style0 from "./OrganizeInvite.vue?vue&type=style&index=0&id=56605f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56605f02",
  null
  
)

export default component.exports